<!-- Single design article view -->
<template>
  <div class="row" style="min-height: 100vh">
    <post-view v-if="design != null" :post="design" />
  </div>
</template>

<script>
export default {
  name: "Design",
  data() {
    return {
      id: null,
      design: null
    };
  },
  methods: {
    getDesign() {
      this.$http
        .get(this.$store.state.apiURL + "designs/" + this.id)
        .then(response => {
          this.design = response.body.design;
        });
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.getDesign();
  }
};
</script>

<style scoped>
</style>